/**
 * Client-side helpers for Artifacts / Companion markdown display.
 * Mirrors backend/lib/markdownToHtml.js fixups for older notes that stored literal **.
 */

export function hasUnresolvedMarkdown(text) {
  const s = String(text || '');
  if (!s) return false;
  return /(\*\*[^*\n]+?\*\*|__[^_\n]+?__)/m.test(s);
}

/** Turn leftover **bold** into <strong> after marked (or inside HTML bodies). */
export function fixLiteralMarkdownMarkers(text) {
  return String(text || '')
    .replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>')
    .replace(/__([^_\n]+?)__/g, '<strong>$1</strong>');
}

/**
 * If "markdown" is actually HTML-with-literal-**, strip light wrappers so marked can run.
 */
export function coerceMarkdownSource(text) {
  const t = String(text || '');
  if (!hasUnresolvedMarkdown(t)) return t;
  const tags = t.match(/<\/?[a-zA-Z][^>]*>/g) || [];
  if (tags.length === 0) return t;
  // Unwrap trivial HTML so ** can be parsed as MD
  return t
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>\s*<p>/gi, '\n\n')
    .replace(/^\s*<p>|<\/p>\s*$/gi, '')
    .replace(/<\/?strong>/gi, '**')
    .replace(/<\/?b>/gi, '**');
}
